module.exports = __webpack_public_path__ + "static/media/SPHB1_EDITSINGLE.0e144a33.mp4";